module.exports = __webpack_public_path__ + "static/engranajes-4cbd3073b71c9204dee4434ba363c646.png";